import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Observable } from 'rxjs/Observable';
import { TOKEN_PADRAO } from '../../app.constants';
import { FuncoesCriptografia } from '../shared/util/Funcoes-criptografia';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    jwtHelper = new JwtHelperService();

    constructor(
        private route: Router
    ) { }


    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        const token = localStorage.getItem(TOKEN_PADRAO);

        if (token) {
            const cloned = request.clone({
                headers: request.headers.set('Authorization', token)
            });
            return next.handle(cloned);
        } else {
            return next.handle(request);
        }

    }



    public getJwtCdLogin() {
        if (!this.tokenIsError()) {
            const cdLogin = this.jwtHelper.decodeToken(FuncoesCriptografia.descriptografiaAvancada(localStorage.getItem(TOKEN_PADRAO).substring(7)))['sub'];
            return FuncoesCriptografia.descriptografiaAvancada(cdLogin);
        }
        return null
    }

    public getJwtCdCentrus() {
        if (!this.tokenIsError()) {
            const cdCentrus = this.jwtHelper.decodeToken(FuncoesCriptografia.descriptografiaAvancada(localStorage.getItem(TOKEN_PADRAO).substring(7)))['jti'];
            return Number( FuncoesCriptografia.descriptografiaAvancada(cdCentrus));
        }
        return null
    }

    tokenIsError() {
        try {
            this.jwtHelper.isTokenExpired(FuncoesCriptografia.descriptografiaAvancada(localStorage.getItem(TOKEN_PADRAO).substring(7)))
            return false;
        } catch (e) {
            localStorage.clear();
            sessionStorage.clear();
            this.route.navigateByUrl('/login');
            return true
        }
    }

    tokenInvalid() {
        if (this.tokenIsError()) {
            return true
        }
        if (this.jwtHelper.isTokenExpired(FuncoesCriptografia.descriptografiaAvancada(localStorage.getItem(TOKEN_PADRAO).substring(7)))) {
            return true;
        }
        return false;

    }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/interceptor/auth.interceptor.ts